import CloseIcon from "@mui/icons-material/Close";
import { Box, colors, Stack } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";

const Header = ({ modalTitle, setIsOpen }) => {
    return (
        <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems="center"
            sx={{
                p: 2,
                background: colors.grey[100],
                borderTopLeftRadius: 2,
                borderTopRightRadius: 2,
            }}
        >
            <Box
                sx={{
                    fontWeight: "bold",
                }}
            >
                {modalTitle}
            </Box>
            <Box>
                <StandartButton
                    variant={ButtonVariant.BLACK_OUTLINED}
                    noBorder
                    onClick={() => {
                        setIsOpen(false);
                    }}
                >
                    <CloseIcon />
                </StandartButton>
            </Box>
        </Stack>
    );
};

export default Header;
